<template>
    <div class="details">
        <div class="img_bxo">
            <div class="bar_box">
                <div    
                    :class="item.path==activation?'active':''"
                    class="bar_botton  bar_botton_magrin "  
                    @click="barclick(item)" 
                    v-for="(item,index) of barlist" :key="index">
                    {{ item.title }}
                </div>
            </div>
            <img class="img " ref="myImage" @load="imageLoaded" :src="activaitem.bg" alt="">
            <div class='font_box '>
                <div class="font_title">{{ activaitem.title }}</div>
                <div class="font_english">{{ activaitem.english }}</div>
            </div>

            <div class="logo_box" @click="breakhome">
                <img class="img_logo" src="../../assets/icons/官网首页_slices/LOGO1.png" alt="">
            </div>
        </div>
        <router-view  :key="$route.fullPath"></router-view>
        <!-- <proser v-if="activaitem.id==1"></proser>
        <hrdigital v-if="activaitem.id==2"></hrdigital>
        <cases v-if="activaitem.id==3"></cases>
        <recruitment v-if="activaitem.id==4"></recruitment>
        <about v-if="activaitem.id==5"></about> -->
        <flexbotton></flexbotton>
        <div class="bottom" v-if="$store.state.detailsbottom==true">        
            <div class="bottom_interior">
                <div class="unveil unfold">
                    <div class="title">产品与服务</div>
                    <div class="subtitle" 
                        v-for="(item,index) of botNavigationlist" :key="index"
                        @click="botNavigation(item)">{{ item.title }}</div>
                </div>
                <div class="unveil news">
                    <div class="title">关于婧贤</div>
                    <div class="subtitle" 
                        v-for="(item,index) of aboutlist" :key="index"
                        @click="botNavigation(item)">{{ item.title }}</div>
                </div> 
                <div class="unveil about">
                    <div class="title">联系我们</div>
                    <div class=" increase">拉萨总部：拉萨经济技术开发区工业中心2期</div>
                    <div class=" increase">联系电话：17354516359</div>
                    <div class=" increase">电子邮箱：service@xzjxrl.com</div>
                    <div class=" increase">企业微信：17354516359</div>
                </div>
            </div>
            <div class="authorize">
                <div class="por">
                    <div>版权所有：西藏婧贤人力资源管理有限公司</div>
                    <a :href="'http://'+'beian.miit.gov.cn/'" target="_blank">藏 ICP 备 2025003038 号-1</a>
                    <div class="nat_box">
                        <img class="nat_img_box" src="../../assets/icons/官网首页_slices/national.png" alt="">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=54010002000200" rel="noreferrer" target="_blank">藏公网安备54010002000200号</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import flexbotton from '../../components/flexbotton.vue'
import about from './components/about.vue'
import cases from './components/cases.vue'
import hrdigital from './components/hr.vue'
import proser from './components/proser.vue'
import recruitment from './components/recruitment.vue'
export default {
    components:{flexbotton,about,cases,hrdigital,proser,recruitment},
    data(){
        return{
            activation:null,
            activaitem:null,
            currentIndexLight:'/proser',
            barlist:[
                {   
                    id:1,
                    bg:require('../../assets/icons/官网首页_slices/details_proser.png'),
                    english:'Products & Services',
                    title:'产品与服务',
                    path:'/proser'},
                {id:2,bg:require('../../assets/icons/官网首页_slices/details_hr.png'),english:'HR digital',title:'HR数字化转型',path:'/hr'},
                {id:3,bg:require('../../assets/icons/官网首页_slices/details_cases.png'),english:'Cases',title:'服务案例',path:'/cases'},
                {id:4,bg:require('../../assets/icons/官网首页_slices/details_recr.png'),english:'Recruitment',title:'招聘信息',path:'/horecruitmentme'},
                {id:5,bg:require('../../assets/icons/官网首页_slices/details_about.png'),english:'About',title:'关于婧贤',path:'/about'},
            ],
            isImageLoaded:null,
            loading:true,
            botNavigationlist:[
                {title:'人力资源外包',path:'/proser',type:1,},
                {title:'劳务派遣服务',path:'/proser',type:2,},
                {title:'岗位外包服务',path:'/proser',type:3,},
                {title:'HR数字转型',path:'/hr'},
            ],
            aboutlist:[
                {title:'产品与服务',path:'/proser'},
                {title:'服务案例',path:'/cases'},
                {title:'联系我们',path:'/about',type:2},
            ],
            
        }
    },
    mounted(){
        var newImg = new Image()
        newImg.src = this.activaitem.bg
        newImg.onerror = () => {   
            newImg.src = ''
        }
        newImg.onload = () => { // 图片加载成功后把地址给原来的img
            this.loading=false;
            this.url =  this.activaitem.bg
        }
        if(window.history && window.history.pushState){
            window.addEventListener('popstate',this.backChange,false)
        }
    },
    created(){
        this.activation =this.$route.path
        
        this.barlist.forEach((item)=>{
            if(item.path==this.$route.path){
                // document.title=item.title,
                this.activaitem=item;
            }
        })
        
    },
    methods:{
        breakhome(){
            this.$store.commit('mdnavaction',0)
            this.$store.commit('routerpath',0)
            this.$router.push('/')
        },
        backChange(){
            location.reload()
        },
        botNavigation(item){
            this.activation=item.path
            this.barlist.forEach((item)=>{
                if(item.path==this.activation){
                    // document.title=item.title,
                    this.activaitem=item;
                }
            })
            this.$router.push({
                path: item.path,
                query:{
                    type:item.type
                }
            })
        },
        imageLoaded() {
            this.isImageLoaded = true;
        },
        barclick(item){
            this.$store.commit('detailsbottom',true)
            this.$store.commit('mdnavaction',item.id)
            this.$store.commit('routerpath',item.id)
            this.activation=item.path;
            this.$router.push({
                path:item.path
            })
            this.barlist.forEach((item)=>{
                if(item.path==this.activation){
                    this.activaitem=item;

                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.details{
    width: 100%;
    height: 100%;
    min-width: 1920px;
    box-sizing: border-box;
    // scroll-behavior: smooth;
    .bottom{
        width: 100%;
        height: 280px;
        background: #1B1E2D;
        box-sizing: border-box;
        position: relative;
        .authorize{
            display: flex;
            justify-content: center;
             .nat_box{
                display: flex;
                align-content: center;
                .nat_img_box{
                    width: 18px;
                    height: 18px;
                    margin-right: 5px;
                }
            }
            .por{
                font-weight: 400;
                color: #909090;
                font-size: 14px;
                width: 732px;
                display: flex;
                justify-content: space-between;
                position: absolute;
                bottom: 14px;
                a{
                    color: #909090;
                }
            }
        }
        .bottom_interior{
            box-sizing: border-box;
            width: 100%;
            height: 89%;
            display: flex;
            .unfold{
                margin-left: 400px;
            }
            .news{
                margin-left: 300px;

            }
            .about{
                margin-left: 322px;
            }
            .contact{
                width: 55%;
            }
            .unveil{
                height: 100%;
                box-sizing: border-box;
                padding-top: 20px;
                .title{
                    font-weight: 500;
                    font-size: 20px;
                    color: #FFFFFF;
                    line-height: 40px;
                }
                .increase{
                   padding-top: 15px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                }
                .subtitle{
                    cursor: pointer;
                    padding-top: 15px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    opacity: 0.6;
                }
                .subtitle:hover{
                    color: #FFFFFF;
                    opacity:1;
                }
            }
        }
    }
    .content_box{
        width:80%;
        height: 80%;
        margin-left: 10%;
        box-sizing: border-box;
        .tab_box{
            width: 20%;
            height: 100%;
            box-sizing: border-box;
            border-right: 1px solid #666;
        }
    }
    .img_bxo{
        width: 100%;
        box-sizing: border-box;
        position: relative;
        height: 400px;
        background: #000;
        .logo_box{
            position: absolute;
            top: 24px;
            left: 160px;
            cursor: pointer;
            .img_logo{
                width: 100%;
                height: 100%;
            }
        }
        .bar_box{   
            box-sizing: border-box;
            position: absolute;
            z-index: 88;
            top: 39px;
            right: 160px;
            color: #fff;
            font-weight: 400;
            font-size: 16px;
            display: flex;
            user-select: none;
            .active{
                border-bottom: 2px solid #027DFC;
                opacity:1 !important;
                box-sizing:border-box;
            } 
            .bar_botton{
                height: 35px;
                line-height: 35px; 
                opacity: 0.6;
                
            }
            .bar_botton_magrin:not(:last-child){margin-right: 39px;}
            .bar_botton:hover{
                opacity: 1;
                color: #fff;
                border-bottom: 2px solid #027DFC;
                cursor: pointer;
                box-sizing: border-box;
            }
        }
        .font_box{
            position: absolute;
            top: 205px;
            left: 44%;
            box-sizing: border-box;
            .font_english{
                font-weight: 400;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 24px;
                text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                margin-top: 22px;
                text-align: center;
            }
            .font_title{
                font-weight: bold;
                font-size: 48px;
                color: #FFFFFF;
                line-height: 24px;
                text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
            }
        }
        .img{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
        }

    }
    .details_bar_box{
        width: 100%;
        height: 120px;
        box-sizing: border-box;
        z-index: 99;
        position: relative;
        top: 0px;
        border: 1px solid red;
        .language_box{
            position: absolute;
            top: 0px;
            right: 0px;
            width: 200px;
            height: 50px;
            display: flex;
            justify-content:space-around;
            align-items: center;
            font-size: 25px;
            color: #000;
            cursor: pointer;
        }
    
        .company_logo{
            box-sizing: border-box;
            position: absolute;
            width: 300px;
            height: 50px;
            top: 55px;
            left: 25px;
            .img_logo{
                width: 48px;
                height: 48px;
                background: #fff;
                border-radius: 50px;
            }
            .company_title{
                font-size: 34px;
                font-weight: bold;
                color: black;
                position: absolute;
                top: 5px;
                left: 70px;
            }
        }
    }
}
</style>